/**
 * 待结算列表
 *
 */

 const toBeSettledUrls = {
	//退款订单列表
	getRefundOrderList: {
		url: '/fortune/refundOrder/getList',
		method: 'get'
	},
    //退款订单编辑
    setRefundOrderEdit: {
		url: '/fortune/refundOrder/edit',
		method: 'post'
	},
    //退款订单结算
    setRefundOrderSettlement: {
		url: '/fortune/refundOrder/settlement',
		method: 'post'
	},
    //退款订单付款失败
    setRefundOrderPaymentFailed: {
		url: '/fortune/refundOrder/paymentFailed',
		method: 'post'
	},
    //退款订单类型
    getRefundOrderType: {
		url: '/fortune/refundOrder/getRefundOrderType',
		method: 'get'
	},
    //退款订单状态
    getRefundOrderStatus: {
		url: '/fortune/refundOrder/getRefundOrderStatus',
		method: 'get'
	},
	//费用订单列表
    getOfficeCostManagementForNotPayFinished: {
		url: '/OfficeCostManagement/GetListForNotPayFinished',
		method: 'get'
	},
	//费用订单=>收款方信息修改
    setOfficeCostManagementEditPayee: {
		url: '/OfficeCostManagement/EditPayee',
		method: 'post'
	},
	//费用订单=>结算
    setOfficeCostManagementSettlement: {
		url: '/OfficeCostManagement/Settlement',
		method: 'post'
	},
	//费用订单=>付款失败
    setOfficeCostManagementPayFail: {
		url: '/OfficeCostManagement/payFail',
		method: 'post'
	},
	//内部往来款待结算列表接口
	getInnerFundTransferWaitCloseList: {
		url: '/InnerFundTransfer/waitCloseList',
		method: 'get'
	},
	//待支付财务结算接口
	setInnerFundTransferClose: {
		url: '/InnerFundTransfer/close',
		method: 'post'
	},
	//财务终止付款接口
	setInnerFundTransferFail: {
		url: '/InnerFundTransfer/fail',
		method: 'post'
	},
	//退款订单列表修改
	editRefundOrderPayment: {
		url: '/fortune/refundOrder/paymentModificationLogAdd',
		method: 'post'
	},
	//退款订单列表获取修改日志列表
	getRefundOrderPaymentLogList: {
		url: '/fortune/refundOrder/paymentModificationLogGetList',
		method: 'get'
	},
	//退款订单修改取消
	cancelRefundOrderPayment: {
		url: '/fortune/refundOrder/paymentModificationLogCancel',
		method: 'post'
	},
	//退款订单修改审核
	auditRefundOrderPayment: {
		url: '/fortune/refundOrder/paymentModificationLogApproval',
		method: 'post'
	},
	//采购订单列表修改
	editAssetPurchasePayment: {
		url: '/assetPurchase/paymentModificationLogAdd',
		method: 'post'
	},
	//采购订单列表获取修改日志列表
	getAssetPurchasePaymentLogList: {
		url: '/assetPurchase/paymentModificationLogGetList',
		method: 'get'
	},
	//采购订单修改取消
	cancelAssetPurchasePayment: {
		url: '/assetPurchase/paymentModificationLogCancel',
		method: 'post'
	},
	//采购订单修改审核
	auditAssetPurchasePayment: {
		url: '/assetPurchase/paymentModificationLogApproval',
		method: 'post'
	},
	//充值订单列表修改
	editTopUpPayment: {
		url: '/fortune/topUp/paymentModificationLogAdd',
		method: 'post'
	},
	//充值订单列表获取修改日志列表
	getTopUpPaymentLogList: {
		url: '/fortune/topUp/paymentModificationLogGetList',
		method: 'get'
	},
	//充值订单修改取消
	cancelTopUpPayment: {
		url: '/fortune/topUp/paymentModificationLogCancel',
		method: 'post'
	},
	//充值订单修改审核
	auditTopUpPayment: {
		url: '/fortune/topUp/paymentModificationLogApproval',
		method: 'post'
	},
	//费用订单列表修改
	editOfficeCostManagementPayment: {
		url: '/officeCostManagement/paymentModificationLogAdd',
		method: 'post'
	},
	//费用订单列表获取修改日志列表
	getOfficeCostManagementPaymentLogList: {
		url: '/officeCostManagement/paymentModificationLogGetList',
		method: 'get'
	},
	//费用订单修改取消
	cancelOfficeCostManagementPayment: {
		url: '/officeCostManagement/paymentModificationLogCancel',
		method: 'post'
	},
	//费用订单修改审核
	auditOfficeCostManagementPayment: {
		url: '/officeCostManagement/paymentModificationLogApproval',
		method: 'post'
	},
	//内部往来款订单列表修改
	editInnerFundTransferPayment: {
		url: '/innerFundTransfer/paymentModificationLogAdd',
		method: 'post'
	},
	//内部往来款订单列表获取修改日志列表
	getInnerFundTransferPaymentLogList: {
		url: '/innerFundTransfer/paymentModificationLogGetList',
		method: 'get'
	},
	//内部往来款订单修改取消
	cancelInnerFundTransferPayment: {
		url: '/innerFundTransfer/paymentModificationLogCancel',
		method: 'post'
	},
	//内部往来款订单修改审核
	auditInnerFundTransferPayment: {
		url: '/innerFundTransfer/paymentModificationLogApproval',
		method: 'post'
	},
}

export default toBeSettledUrls